import script from "./SkeletonBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonBox.vue?vue&type=script&setup=true&lang=js"

import "./SkeletonBox.vue?vue&type=style&index=0&id=e307e898&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/wp-content/themes/stewartrealtor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e307e898"]])

export default __exports__